/**
 * Configuración base de Axios para las peticiones HTTP
 */

import axios from "axios";

// Detectar automáticamente la URL del API según el entorno
const getApiUrl = (): string => {
  // Si hay variable de entorno, usarla
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // Detectar según el host actual
  const hostname = window.location.hostname;

  if (hostname === "localhost" || hostname === "127.0.0.1") {
    // Desarrollo local - llamar directamente al backend
    return "http://localhost:5000/api";
  } else {
    // Producción - usar el mismo origen (el proxy reverso redirige al backend)
    // Esto funciona porque el frontend en :3000 tiene un proxy que redirige /api/* a localhost:5000
    return `${window.location.origin}/api`;
  }
};

// URL base de la API
const BASE_URL = getApiUrl();

// Crear instancia de Axios
export const apiClient = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Interceptor para requests
apiClient.interceptors.request.use(
  (config) => {
    // Aquí puedes agregar tokens de autenticación si es necesario
    // config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Interceptor para responses
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Manejo global de errores
    if (error.response) {
      // El servidor respondió con un código de error
      console.error("Error de respuesta:", error.response.data);
    } else if (error.request) {
      // La petición fue hecha pero no hubo respuesta
      console.error("Error de red:", error.request);
    } else {
      // Algo pasó al configurar la petición
      console.error("Error:", error.message);
    }
    return Promise.reject(error);
  },
);

export default apiClient;
